export const selector = 'dbAProcessKey';

/* @ngInject */
export default function ProcessKeyDirective() {
    return {
        restrict: 'A',
        scope: {
            callback: `&${selector}`
        },

        link(scope, element) {
            element.on('keydown', keypressHandler);
            scope.$on('$destroy', () => element.off('keydown', keypressHandler));

            function keypressHandler(event) {
                let value = scope.callback({
                    code: event.which == null ? event.keyCode : event.which
                });

                scope.$applyAsync();

                if (!value) {
                    event.preventDefault();
                    event.stopPropagation();
                }

                return value;
            }
        }
    };
}



// WEBPACK FOOTER //
// ./src/application/directive/process-key/process-key.directive.js